import { Component } from '@angular/core';
import * as i0 from "@angular/core";
export class PageNotFoundComponent {
    constructor() { }
    static { this.ɵfac = function PageNotFoundComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PageNotFoundComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PageNotFoundComponent, selectors: [["app-page-not-found"]], standalone: false, decls: 2, vars: 0, template: function PageNotFoundComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "h3");
            i0.ɵɵtext(1, "Ooops, doesn't look like this page exists!");
            i0.ɵɵelementEnd();
        } }, styles: ["\n\n[_nghost-%COMP%] {\n  padding: 16px;\n  display: flex;\n}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(PageNotFoundComponent, { className: "PageNotFoundComponent", filePath: "libs/web/angular/shared/util/error-handling/src/lib/page-not-found/page-not-found.component.ts", lineNumber: 9 }); })();
//# sourceMappingURL=page-not-found.component.js.map